var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSellAndSoldBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33329 5.1665L11.6666 5.1665L11.6666 12.7498C11.6666 12.9045 11.6052 13.0529 11.4958 13.1623C11.3864 13.2717 11.238 13.3332 11.0833 13.3332L2.91663 13.3332C2.76192 13.3332 2.61354 13.2717 2.50415 13.1623C2.39475 13.0529 2.33329 12.9045 2.33329 12.7498L2.33329 5.1665ZM3.49996 6.33317L3.49996 12.1665L10.5 12.1665L10.5 6.33317L3.49996 6.33317ZM5.24996 7.49984H6.41663L6.41663 10.9998H5.24996L5.24996 7.49984ZM7.58329 7.49984H8.74996L8.74996 10.9998H7.58329L7.58329 7.49984ZM4.08329 3.4165V2.24984C4.08329 2.09513 4.14475 1.94675 4.25415 1.83736C4.36354 1.72796 4.51192 1.6665 4.66663 1.6665L9.33329 1.6665C9.488 1.6665 9.63638 1.72796 9.74577 1.83736C9.85517 1.94675 9.91663 2.09513 9.91663 2.24984V3.4165L12.8333 3.4165V4.58317L1.16663 4.58317L1.16663 3.4165L4.08329 3.4165ZM5.24996 2.83317V3.4165H8.74996V2.83317H5.24996Z",
    fill: "url(#paint0_linear_150_2578)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_2578",
    x1: 6.99996,
    y1: 1.6665,
    x2: 6.99996,
    y2: 13.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC382C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_2578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellAndSoldBin);
export default __webpack_public_path__ + "static/media/SellAndSold-bin.9e97c96ca3f1163ad5bcdb1f6168f078.svg";
export { ForwardRef as ReactComponent };